export const treeData = [
  {
    name: "ભીમજી",
    photo:
      "https://png.pngtree.com/png-vector/20191101/ourmid/pngtree-cartoon-color-simple-male-avatar-png-image_1934459.jpg",
    child: true,
    children: [
      {
        name: "હરજી",
        photo:
          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
        child: true,
        children: [
          {
            name: "હરજી",
            photo:
              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
            child: true,
            children: [
              {
                name: "ધર્મસી",
                photo:
                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                child: true,
                children: [
                  {
                    name: "ઝેટા",
                    photo:
                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                    child: true,
                    children: [
                      {
                        name: "શામજી",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: true,
                        children: [
                          {
                            name: "વેલજી",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                          {
                            name: "વાલજી",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                          {
                            name: "કરશન",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                        ],
                      },
                      {
                        name: "મંજી",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: true,
                        children: [
                          {
                            name: "કંજી",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                          {
                            name: "કુંવરજી",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                        ],
                      },
                      {
                        name: "લાખુ",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: true,
                        children: [
                          {
                            name: "શિબજી",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                          {
                            name: "વાલજી",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                          {
                            name: "મુરજી",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: true,
                            children: [
                              {
                                name: "પ્રેમજી",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                              {
                                name: "લાલજી",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                              {
                                name: "રામજી",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                              {
                                name: "વિશ્રામ",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                name: "અંબા",
                photo:
                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                child: true,
                children: [
                  {
                    name: "ખીમજી",
                    photo:
                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                    child: true,
                    children: [
                      {
                        name: "ઝકુ",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: false,
                      },
                    ],
                  },
                  {
                    name: "મંજી",
                    photo:
                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                    child: true,
                    children: [
                      {
                        name: "શિબજી",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: false,
                      },
                      {
                        name: "લખમણ",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: false,
                      },
                      {
                        name: "મંજી",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: false,
                      },
                      {
                        name: "નરણ",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: true,
                        children: [
                          {
                            name: "જેદવજી",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                          {
                            name: "ગોપાલ",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                          {
                            name: "ગોવિંદ",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                          {
                            name: "હરજી",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                          {
                            name: "વિમજી",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                        ],
                      },
                    ],
                  },
                  {
                    name: "વેલજી",
                    photo:
                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                    child: true,
                    children: [
                      {
                        name: "શિબજી",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: false,
                      },
                      {
                        name: "જીના",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: false,
                      },
                      {
                        name: "ગોવિંદ",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: false,
                      },
                    ],
                  },
                ],
              },
              {
                name: "કરશન",
                photo:
                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                child: true,
                children: [
                  {
                    name: "પુણા",
                    photo:
                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                    child: true,
                    children: [
                      {
                        name: "હિરજી",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: false,
                      },
                      {
                        name: "માવજી",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: false,
                      },
                    ],
                  },
                  {
                    name: "રવજી",
                    photo:
                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                    child: true,
                    children: [
                      {
                        name: "વાલજી",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: false,
                      },
                      {
                        name: "દેવજી",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: false,
                      },
                    ],
                  },
                  {
                    name: "જીના",
                    photo:
                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                    child: true,
                    children: [
                      {
                        name: "કંજી",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: false,
                      },
                      {
                        name: "વેલજી",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: false,
                      },
                    ],
                  },
                ],
              },
              {
                name: "રુધા",
                photo:
                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                child: true,
                children: [
                  {
                    name: "માવજી",
                    photo:
                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                    child: true,
                    children: [
                      {
                        name: "બેગર",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: false,
                      },
                      {
                        name: "રવજી",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: true,
                        children: [
                          {
                            name: "રામજી",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: true,
                            children: [
                              {
                                name: "જગદીશ",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                              {
                                name: "કમલેશ",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                            ],
                          },
                          {
                            name: "કરશન",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: true,
                            children: [
                              {
                                name: "રાજેશ",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                              {
                                name: "બિજોય",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                            ],
                          },
                        ],
                      },
                      {
                        name: "લાલજી",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: true,
                        children: [
                          {
                            name: "કરશન",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: true,
                            children: [
                              {
                                name: "ધર્મેશ",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                              {
                                name: "કિરણ",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    name: "અરજન",
                    photo:
                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                    child: true,
                    children: [
                      {
                        name: "લધા",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: true,
                        children: [
                          {
                            name: "પ્રેમજી",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: true,
                            children: [
                              {
                                name: "ચિલવતી",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                              {
                                name: "વરત",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: true,
                                children: [
                                  {
                                    name: "દીપા",
                                    photo:
                                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                    child: false,
                                  },
                                  {
                                    name: "સીમા",
                                    photo:
                                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                    child: false,
                                  },
                                  {
                                    name: "તુલશી",
                                    photo:
                                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                    child: false,
                                  },
                                ],
                              },
                              {
                                name: "નરણ",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: true,
                                children: [
                                  {
                                    name: "બિંદિયા",
                                    photo:
                                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                    child: false,
                                  },

                                  {
                                    name: "ભવેશ",
                                    photo:
                                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                    child: false,
                                  },
                                  {
                                    name: "ભવેશ",
                                    photo:
                                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                    child: false,
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            name: "રામજી",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: true,
                            children: [
                              {
                                name: "નિતિન",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                              {
                                name: "શયામ",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                              {
                                name: "નરેશ",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                            ],
                          },
                          {
                            name: "હિરજી",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: true,
                            children: [
                              {
                                name: "દિનેશ",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                              {
                                name: "નરેન્દ્ર",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                            ],
                          },
                        ],
                      },
                      {
                        name: "રત્ન",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: true,
                        children: [
                          {
                            name: "જાડવજી",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: true,
                            children: [
                              {
                                name: "નરણ",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: true,
                                children: [
                                  {
                                    name: "મનીશ",
                                    photo:
                                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                    child: false,
                                  },
                                ],
                              },
                              {
                                name: "મંજી",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: true,
                                children: [
                                  {
                                    name: "હરીશ",
                                    photo:
                                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                    child: false,
                                  },
                                  {
                                    name: "સંજય",
                                    photo:
                                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                    child: false,
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            name: "શામજી",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: true,
                            children: [
                              {
                                name: "ભીમજી",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",

                                child: true,
                                children: [
                                  {
                                    name: "હિતેશ",
                                    photo:
                                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                    child: false,
                                  },
                                  {
                                    name: "નિલેશ",
                                    photo:
                                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                    child: false,
                                  },
                                ],
                              },
                              {
                                name: "મંજી",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                              {
                                name: "માવજી",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                            ],
                          },
                        ],
                      },
                      {
                        name: "વાલજી",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: true,

                        children: [
                          {
                            name: "વિશ્રામ",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: true,
                            children: [
                              {
                                name: "અરવિંદ",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                              {
                                name: "દેવજી",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                            ],
                          },
                        ],
                      },
                      {
                        name: "જેઠા",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: true,
                        children: [
                          {
                            name: "હરજી",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                          {
                            name: "ગોવિંદ",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: true,
                            children: [
                              {
                                name: "જાડવજી",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: true,
                                children: [
                                  {
                                    name: "જયેશ",
                                    photo:
                                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                    child: false,
                                  },
                                  {
                                    name: "સંજય",
                                    photo:
                                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                    child: false,
                                  },
                                  {
                                    name: "પ્રીતેશ",
                                    photo:
                                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                    child: false,
                                  },
                                ],
                              },
                              {
                                name: "કિશોર",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                  child: true,
                                  children: [
                                    {
                                      name: "ભવિન",
                                      photo:
                                        "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                      child: false,
                                    }

                                  ],
                              },
                            ],
                          },
                          {
                            name: "હિરજી",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                        ],
                      },
                    ],
                  },
                  {
                    name: "જવડા",
                    photo:
                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                    child: true,
                    children: [
                      {
                        name: "મંજી",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: true,
                        children: [
                          {
                            name: "ભીમજી",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: true,
                            children: [
                              {
                                name: "ભરત",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                              {
                                name: "શાંતિ",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                            ],
                          },
                          {
                            name: "કરશન",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: true,
                            children: [
                              {
                                name: "વિનોદ",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                            ],
                          },
                        ],
                      },
                      {
                        name: "દેવજી",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                          child: true,
                          children: [
                            {
                              name: "પરબત",
                              photo:
                                "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                              child: false,
                            },
                            {
                              name: "પ્રેમજી",
                              photo:
                                "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: true,
                                children: [
                                  {
                                    name: "જયેશ",
                                    photo:
                                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                    child: false,
                                  },
                                  {
                                    name: "સ્મીતેશ",
                                    photo:
                                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                    child: false,
                                  }

                                ],
                            },

                          ],
                      },
                      {
                        name: "ગોવિંદ",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: true,
                        children: [
                          {
                            name: "દિનેશ",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: true,
                            children: [
                              {
                                name: "જગદીશ",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                            ],
                          },
                          {
                            name: "મહેશ",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: true,
                            children: [
                              {
                                name: "દર્શન",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                            ],
                          },
                          {
                            name: "ધીરજ",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                        ],
                      },
                      {
                        name: "હરજી",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: true,
                        children: [
                          {
                            name: "મુકુંદ",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: true,
                            children: [
                              {
                                name: "પ્રીતમ",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                            ],
                          },
                          {
                            name: "હરીશ",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: true,
                            children: [
                              {
                                name: "પ્રવેશ",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    name: "રામજી",
                    photo:
                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                    child: false,
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];
export const treeData1 = [
  {
    name: "ભીમજી",
    photo:
      "https://png.pngtree.com/png-vector/20191101/ourmid/pngtree-cartoon-color-simple-male-avatar-png-image_1934459.jpg",
    child: true,
    children: [
      {
        name: "હરજી",
        photo:
          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
        child: true,
        children: [
          {
            name: "હરજી",
            photo:
              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
            child: true,
            children: [
              {
                name: "ધર્મસી",
                photo:
                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                child: true,
                children: [
                  {
                    name: "Jheta",
                    photo:
                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                    child: true,
                    children: [
                      {
                        name: "Shamji",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: true,
                        children: [
                          {
                            name: "Velji",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                          {
                            name: "Valji",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                          {
                            name: "Karshan",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                        ],
                      },
                      {
                        name: "Manji",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: true,
                        children: [
                          {
                            name: "Kanji",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                          {
                            name: "Kunvarji",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                        ],
                      },
                      {
                        name: "Lakhu",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: true,
                        children: [
                          {
                            name: "Shibji",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                          {
                            name: "Valji",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                          {
                            name: "Murji",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: true,
                            children: [
                              {
                                name: "Premji",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                              {
                                name: "Lalji",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                              {
                                name: "Ramji",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                              {
                                name: "Vishram",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                name: "Amba",
                photo:
                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                child: true,
                children: [
                  {
                    name: "Khimji",
                    photo:
                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                    child: true,
                    children: [
                      {
                        name: "Jhaku",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: false,
                      },
                    ],
                  },
                  {
                    name: "Manji",
                    photo:
                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                    child: true,
                    children: [
                      {
                        name: "Shibji",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: false,
                      },
                      {
                        name: "Lakhman",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: false,
                      },
                      {
                        name: "Manji",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: false,
                      },
                      {
                        name: "Naran",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: true,
                        children: [
                          {
                            name: "Jedavji",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                          {
                            name: "Gopal",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                          {
                            name: "Govind",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                          {
                            name: "Harji",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                          {
                            name: "Vhimji",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                        ],
                      },
                    ],
                  },
                  {
                    name: "Velji",
                    photo:
                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                    child: true,
                    children: [
                      {
                        name: "Shibji",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: false,
                      },
                      {
                        name: "Jina",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: false,
                      },
                      {
                        name: "Govind",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: false,
                      },
                    ],
                  },
                ],
              },
              {
                name: "Karshan",
                photo:
                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                child: true,
                children: [
                  {
                    name: "Puna",
                    photo:
                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                    child: true,
                    children: [
                      {
                        name: "Hirji",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: false,
                      },
                      {
                        name: "Mavji",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: false,
                      },
                    ],
                  },
                  {
                    name: "Ravji",
                    photo:
                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                    child: true,
                    children: [
                      {
                        name: "Valji",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: false,
                      },
                      {
                        name: "Devji",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: false,
                      },
                    ],
                  },
                  {
                    name: "Jina",
                    photo:
                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                    child: true,
                    children: [
                      {
                        name: "Kanji",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: false,
                      },
                      {
                        name: "Velji",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: false,
                      },
                    ],
                  },
                ],
              },
              {
                name: "Rudha",
                photo:
                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                child: true,
                children: [
                  {
                    name: "Mavji",
                    photo:
                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                    child: true,
                    children: [
                      {
                        name: "Begar",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: false,
                      },
                      {
                        name: "Ravji",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: true,
                        children: [
                          {
                            name: "Ramji",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: true,
                            children: [
                              {
                                name: "Jagdhish",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                              {
                                name: "Kamlesh",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                            ],
                          },
                          {
                            name: "Karsan",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: true,
                            children: [
                              {
                                name: "Rajesh",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                              {
                                name: "Bijoy",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                            ],
                          },
                        ],
                      },
                      {
                        name: "Lalji",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: true,
                        children: [
                          {
                            name: "Karsan",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: true,
                            children: [
                              {
                                name: "Darmesh",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                              {
                                name: "Kiran",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    name: "Arjan",
                    photo:
                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                    child: true,
                    children: [
                      // {
                      //   name: "Ladha",
                      //   photo:
                      //     "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //   child: true,
                      //   children: [
                      //     // {
                      //     //   name: "Premji",
                      //     //   photo:
                      //     //     "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //     //   child: true,
                      //     //   children: [
                      //     //     {
                      //     //       name: "Cilavati",
                      //     //       photo:
                      //     //         "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //     //       child: false,
                      //     //     },
                      //     //     {
                      //     //       name: "Varat",
                      //     //       photo:
                      //     //         "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //     //       child: true,
                      //     //       children: [
                      //     //         {
                      //     //           name: "Deepa",
                      //     //           photo:
                      //     //             "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //     //           child: false,
                      //     //         },
                      //     //         {
                      //     //           name: "Seema",
                      //     //           photo:
                      //     //             "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //     //           child: false,
                      //     //         },
                      //     //         {
                      //     //           name: "Tulshi",
                      //     //           photo:
                      //     //             "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //     //           child: false,
                      //     //         },
                      //     //       ],
                      //     //     },
                      //     //     {
                      //     //       name: "Naran",
                      //     //       photo:
                      //     //         "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //     //       child: true,
                      //     //       children: [
                      //     //         {
                      //     //           name: "Bindiya",
                      //     //           photo:
                      //     //             "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //     //           child: false,
                      //     //         },

                      //     //         {
                      //     //           name: "Bhavesh",
                      //     //           photo:
                      //     //             "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //     //           child: false,
                      //     //         },
                      //     //         {
                      //     //           name: "Roshni",
                      //     //           photo:
                      //     //             "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //     //           child: false,
                      //     //         },
                      //     //       ],
                      //     //     },
                      //     //   ],
                      //     // },
                      //     {
                      //       name: "Ramji",
                      //       photo:
                      //         "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //       child: true,
                      //       children: [
                      //         {
                      //           name: "Nitin",
                      //           photo:
                      //             "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //           child: false,
                      //         },
                      //         {
                      //           name: "Shayam",
                      //           photo:
                      //             "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //           child: false,
                      //         },
                      //         {
                      //           name: "Naresh",
                      //           photo:
                      //             "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //           child: false,
                      //         },
                      //       ],
                      //     },
                      //     {
                      //       name: "Hirji",
                      //       photo:
                      //         "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //       child: true,
                      //       children: [
                      //         {
                      //           name: "Dinesh",
                      //           photo:
                      //             "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //           child: false,
                      //         },
                      //         {
                      //           name: "Narendra",
                      //           photo:
                      //             "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //           child: false,
                      //         },
                      //       ],
                      //     },
                      //   ],
                      // },
                      // {
                      //   name: "Ratna",
                      //   photo:
                      //     "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //   child: true,
                      //   children: [
                      //     {
                      //       name: "Jadavji",
                      //       photo:
                      //         "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //       child: true,
                      //       children: [
                      //         {
                      //           name: "Naran",
                      //           photo:
                      //             "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //           child: true,
                      //           children: [
                      //             {
                      //               name: "Manish",
                      //               photo:
                      //                 "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //               child: false,
                      //             },
                      //           ],
                      //         },
                      //         {
                      //           name: "Manji",
                      //           photo:
                      //             "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //           child: true,
                      //           children: [
                      //             {
                      //               name: "Harish",
                      //               photo:
                      //                 "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //               child: false,
                      //             },
                      //             {
                      //               name: "Sanjay",
                      //               photo:
                      //                 "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //               child: false,
                      //             },
                      //           ],
                      //         },
                      //       ],
                      //     },
                      //     {
                      //       name: "Shamji",
                      //       photo:
                      //         "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //       child: true,
                      //       children: [
                      //         {
                      //           name: "Bhimji",
                      //           photo:
                      //             "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",

                      //           child: true,
                      //           children: [
                      //             {
                      //               name: "Hitesh",
                      //               photo:
                      //                 "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //               child: false,
                      //             },
                      //             {
                      //               name: "Nilesh",
                      //               photo:
                      //                 "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //               child: false,
                      //             },
                      //           ],
                      //         },
                      //         {
                      //           name: "Manji",
                      //           photo:
                      //             "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //           child: false,
                      //         },
                      //         {
                      //           name: "Mavji",
                      //           photo:
                      //             "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //           child: false,
                      //         },
                      //       ],
                      //     },
                      //   ],
                      // },
                      // {
                      //   name: "Valji",
                      //   photo:
                      //     "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //   child: true,

                      //   children: [
                      //     {
                      //       name: "Vishram",
                      //       photo:
                      //         "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //       child: true,
                      //       children: [
                      //         {
                      //           name: "Arvind",
                      //           photo:
                      //             "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //           child: false,
                      //         },
                      //         {
                      //           name: "Devji",
                      //           photo:
                      //             "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                      //           child: false,
                      //         },
                      //       ],
                      //     },
                      //   ],
                      // },
                      {
                        name: "Jetha",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: true,
                        children: [
                          {
                            name: "Harji",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                          {
                            name: "Govind",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: true,
                            children: [
                              {
                                name: "Jadavji",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: true,
                                children: [
                                  {
                                    name: "Jayesh",
                                    photo:
                                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                    child: false,
                                  },
                                  {
                                    name: "Sanjay",
                                    photo:
                                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                    child: false,
                                  },
                                  {
                                    name: "Pritesh",
                                    photo:
                                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                    child: false,
                                  },
                                ],
                              },
                              {
                                name: "Kishor",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                  child: true,
                                  children: [
                                    {
                                      name: "Bhavin",
                                      photo:
                                        "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                      child: false,
                                    }

                                  ],
                              },
                            ],
                          },
                          {
                            name: "Hirji",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                        ],
                      },
                    ],
                  },
                  {
                    name: "Javda",
                    photo:
                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                    child: true,
                    children: [
                      {
                        name: "Manji",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: true,
                        children: [
                          {
                            name: "Bhimji",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: true,
                            children: [
                              {
                                name: "Bharat",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                              {
                                name: "Shanti",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                            ],
                          },
                          {
                            name: "Karsan",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: true,
                            children: [
                              {
                                name: "Vinod",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                            ],
                          },
                        ],
                      },
                      {
                        name: "Devji",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                          child: true,
                          children: [
                            {
                              name: "Parbat",
                              photo:
                                "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                              child: false,
                            },
                            {
                              name: "Premji",
                              photo:
                                "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: true,
                                children: [
                                  {
                                    name: "Jayesh",
                                    photo:
                                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                    child: false,
                                  },
                                  {
                                    name: "Smithesh",
                                    photo:
                                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                    child: false,
                                  }

                                ],
                            },

                          ],
                      },
                      {
                        name: "Govind",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: true,
                        children: [
                          {
                            name: "Dinesh",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: true,
                            children: [
                              {
                                name: "Jagadish",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                            ],
                          },
                          {
                            name: "Mahesh",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: true,
                            children: [
                              {
                                name: "Darshan",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                            ],
                          },
                          {
                            name: "Dhiraj",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: false,
                          },
                        ],
                      },
                      {
                        name: "Harji",
                        photo:
                          "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                        child: true,
                        children: [
                          {
                            name: "Mukund",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: true,
                            children: [
                              {
                                name: "Pritam",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                            ],
                          },
                          {
                            name: "Harish",
                            photo:
                              "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                            child: true,
                            children: [
                              {
                                name: "Pravesh",
                                photo:
                                  "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                                child: false,
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    name: "Ramji",
                    photo:
                      "https://img.freepik.com/premium-vector/young-man-avatar-character-vector-illustration-design_24877-18514.jpg?w=2000",
                    child: false,
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];
